import { useMutation, useQuery } from '@tanstack/react-query';
import { httpService } from '../../../utils/apiService';

const useGetSingleTeamUser = (params = {}, options = {}) => {
  const { id, token } = params;

  return useQuery({
    queryKey: ['SINGLE_TEAM_USER', id],
    queryFn: async () => {
      const response = await httpService.get(
        `/api/team-users/info/${id}`,
        token
      );

      return response.data;
    },
    ...options,
  });
};

const useGetAllTeamUsers = (params = {}, options = {}) => {
  const { offset, limit, search } = params;

  return useQuery({
    queryKey: ['ALL_TEAM_USERS', offset, limit, search], // ✅ Query key updates when params change
    queryFn: async () => {
      const response = await httpService.get(`/team-users/list?offset=${offset}&limit=${limit}&search=${search}`, {
      });

      return response.data.data;
    },
    ...options,
  });
};

const useCreateTeamUser = (options = {}) => {
  return useMutation({
    mutationKey: ['CREATE_TEAM_USER'],
    mutationFn: async (payload) => {
      const response = await httpService.post(`/team-users/create`, payload);

      return response.data;
    },
    ...options,
  });
};

const useUpdateTeamUser = (options = {}) => {
  return useMutation({
    mutationKey: ['UPDATE_TEAM_USER'],
    mutationFn: async (payload) => {
      const response = await httpService.post(
        `/team-users/update/${payload?.id}`,
        payload.data
      );

      return response.data.data;
    },
    ...options,
  });
};

const useDeleteTeamUser = (options = {}) => {
  return useMutation({
    mutationKey: ['UPDATE_TEAM_USER'],
    mutationFn: async (payload) => {
      const response = await httpService.post(`/team-users/delete/${payload}`);

      return response.data.data;
    },
    ...options,
  });
};

export {
  useGetSingleTeamUser,
  useGetAllTeamUsers,
  useCreateTeamUser,
  useUpdateTeamUser,
  useDeleteTeamUser,
};
